export const fromStations = [
    'Secunderabad', 
    'Katpadi',
    'Howrah',
    'Nagpur',
    'Ahmedabad',
    'Delhi',
    'Surat',
    'Chandigarh',
    'Dhanbad',
    'Moradabad',
    'Pune',
    'Kanpur',
    'Kollam',
    'Agra Cantonment',
    'Ludhiana',
    'Guwahati',
    'Manmad',
    

]
export const toStations = [
    'Varanasi',
    'Vadodara',
    'Chandigarh',
    'Barddhaman',
    'Udaipur',
    'Salem',
    'Howrah',
    'Coimbatore',
    'Hubli',
    'Pune',
    'Thrissur',
    'Dhanbad',
    'Vijayawada',
    'Anand',
    'Kharagpur',
    'Ahmedabad',
    'Gorakhpur',
]